// extracted by mini-css-extract-plugin
module.exports = {"colorsSelector":"ColorsSelector_colorsSelector__AfQrx","list":"ColorsSelector_list__8v8XO","label":"ColorsSelector_label__nDjVX"};